//elevation(μm)  -> localComp(μm)
const table = new Map<number, number>();

export const LocalCompRegistry = {
    set(elevation: number, localComp: number) {
        table.set(elevation, localComp);
    },
    get(elevation: number): number {
        return table.get(elevation) ?? 0;
    },
    clear() {
        table.clear();
    },
    entries(): Array<[number, number]> {
        return Array.from(table.entries());
    },
    replace(entries: Array<[number, number]>) {
        table.clear();
        entries.forEach(([elevation, localComp]) => table.set(elevation, localComp));
    }
};
